import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { addClass, removeClass } from '@/utils';
import { SettingsModule } from '@/store/modules/settings';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "clickNotClose", void 0);
    _defineProperty(_this, "buttonTop", void 0);
    _defineProperty(_this, "show", false);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "theme",
    get: function get() {
      return SettingsModule.theme;
    }
  }, {
    key: "onShowChange",
    value: function onShowChange(value) {
      if (value && !this.clickNotClose) {
        this.addEventClick();
      }
      if (value) {
        addClass(document.body, 'showRightPanel');
      } else {
        removeClass(document.body, 'showRightPanel');
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.insertToBody();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var elx = this.$refs.rightPanel;
      elx.remove();
    }
  }, {
    key: "addEventClick",
    value: function addEventClick() {
      window.addEventListener('click', this.closeSidebar);
    }
  }, {
    key: "closeSidebar",
    value: function closeSidebar(ev) {
      var parent = ev.target.closest('.rightPanel');
      if (!parent) {
        this.show = false;
        window.removeEventListener('click', this.closeSidebar);
      }
    }
  }, {
    key: "insertToBody",
    value: function insertToBody() {
      var elx = this.$refs.rightPanel;
      var body = document.querySelector('body');
      if (body) {
        body.insertBefore(elx, body.firstChild);
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], default_1.prototype, "clickNotClose", void 0);
__decorate([Prop({
  default: 250
})], default_1.prototype, "buttonTop", void 0);
__decorate([Watch('show')], default_1.prototype, "onShowChange", null);
default_1 = __decorate([Component({
  name: 'RightPanel'
})], default_1);
export default default_1;